// apps/web/src/pages/admin/today/today-operations.ts — Phase 5 plan 05-04
// + Quick 260803-ger.
//
// Operation strings for the Today surface. The query names are
// suffixed with the page name so the 401-retry interceptor in
// `lib/api.ts` can detect admin ops.

import { gql } from "graphql-request";

export const DATE_SUMMARY_QUERY = gql`
  query DateSummaryToday($date: String!) {
    dateSummary(date: $date) {
      booked
      capacity
      holdback
      remaining
    }
  }
`;

export const TODAY_RESERVATIONS_QUERY = gql`
  query TodayReservations($today: String!) {
    reservations(filter: { fromDate: $today, toDate: $today }, limit: 200) {
      items {
        id
        reservationNumber
        status
        source
        startsAt
        durationMinutes
        partySize
        guestName
        guestEmail
        guestPhone
        internalNote
        slotDefinitionId
        serviceDate
      }
      nextCursor
    }
  }
`;
